export default {
  Eyebrow: 'Define a reusable plan',
  Title: 'Add playbook details',
  EditTitle: 'Edit Playbook details',
  Cancel: 'Cancel',
  Create: 'Create playbook',
  SaveChanges: 'Save changes',
  TitleLabel: 'Playbook name',
  TitlePlaceholder: 'Enter playbook title',
  DescriptionLabel: 'Description',
  DescriptionPlaceholder: 'Feel free to include specific details',
  GroupLabel: 'Group',
  NewGroupPlaceholder: 'Enter group name',
  GroupMode: {
    Existing: 'Existing group',
    New: 'New group',
  },
  Tabs: {
    Basic: 'Basic',
    Steps: 'Steps',
  },
  StepEditor: {
    Placeholder: 'e.g. Send welcome email on day 1 @sarah',
    Footer: 'Mention a day to group automatically. Optionally, use @name to assign, /skill to link a skill.',
    Loading: 'Loading...',
    NoMatches: 'No matches found.',
    AssignedTo: 'Assigned to #{name}',
    Day: 'Due on day #{day}',
  },
  StepPreview: {
    Title: 'Steps preview',
    FallbackTitle: 'Step #{index}',
    Day: 'Day #{day}',
    Unassigned: 'Unassigned',
    Unassign: 'Unassign',
  },
};
